import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function Blog() {
  const [selectedCategory, setSelectedCategory] = useState('All Blogs');
  const [searchTerm, setSearchTerm] = useState('');
  const [blogPosts, setBlogPosts] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("./Database/BlogPost_Blog.json");
        const result = await response.json();
        setBlogPosts(result.blogPosts || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const filteredBlogs = blogPosts.filter(post => {
    const matchesCategory = selectedCategory === 'All Blogs' || post.category === selectedCategory;
    const matchesSearchTerm = post.title.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearchTerm;
  });

  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  return (
    <div className="min-h-screen mt-20 mb-5">
      {/* Header */}
      <header className="text-green-600 py-12">
        <div className="container mx-auto text-center">
          <h1 className="text-5xl font-extrabold tracking-tight" data-aos="zoom-in">
            Orgatro IT Blog
          </h1>
        </div>
      </header>

      {/* Navigation */}
      <main className="container mx-auto mt-12 w-10/12">
        <div className="flex justify-center flex-wrap gap-4 mb-10" data-aos="fade-up">
          {['All Blogs', 'UI Design', 'Design System', 'Web Design', 'Webflow', 'SaaS', 'Career', 'Branding', 'Design Process'].map(
            (category, index) => (
              <button
                key={index}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-3 text-lg font-medium border border-gray-300 rounded-full transition-transform duration-300 ease-in-out shadow-sm hover:scale-105 ${
                  selectedCategory === category ? 'bg-green-600 text-white' : 'bg-white text-gray-700'
                }`}
              >
                {category}
              </button>
            )
          )}
          {/* Search Input */}
          <div className="flex items-center gap-3 ml-5">
            <input
              type="text"
              placeholder="Search blogs..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-green-600 text-lg"
            />
            <button
              onClick={() => setSearchTerm(searchTerm)}
              className="px-4 py-2 bg-green-600 text-white font-semibold rounded-full shadow-md hover:bg-green-700 transition duration-300"
              aria-label="Search"
            >
              <i className="fas fa-search"></i>
            </button>
          </div>
        </div>

        {/* Divider */}
        <hr className="border-t border-gray-200 mb-12" />

        {/* Blog Posts Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-aos="fade-up">
          {filteredBlogs.length > 0 ? (
            filteredBlogs.map((post, index) => (
              <div
                key={index}
                className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl duration-500 ease-in-out"
                data-aos="fade-up"
              >
                <div className="perspective">
                  <div className="card">
                    <img
                      src={post.img}
                      alt={post.title}
                      className="w-full h-56 md:h-64 lg:h-72 object-cover"
                    />
                    <div className="p-6">
                      <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-3">{post.title}</h2>
                      <p className="text-green-600 font-medium">{post.category}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center text-gray-600 mt-12">
              <p>No items available.</p>
            </div>
          )}
        </div>
      </main>

      <style jsx>{`
        .perspective {
          perspective: 1000px;
        }

        .card {
          transition: transform 0.5s;
        }

        .card:hover {
          transform: rotateY(5deg) scale(1.05);
        }
      `}</style>
    </div>
  );
}
